import { RegistryPayoutAccountWithdrawalStatus } from '@graphql/generated';
import { createContext } from '@shared/utils/createContext';

export type PayoutAccountInfo = Readonly<{
  status: 'onboarding' | 'readyToUse' | 'pending' | 'rejected';
  statusDetails: string;
  onboardingUrl: string;
  serviceDashboardUrl: string;
  externalAccountLast4: string | null;
  balance?: PayoutAccountBalance;
  withdrawals: ReadonlyArray<PayoutAccountWithdrawal>;
}>;

export type PayoutAccountBalance = Readonly<{
  availablePending: CommerceMonetaryValue;
  available: CommerceMonetaryValue;
  received: CommerceMonetaryValue;
  withdrawn: CommerceMonetaryValue;
  withdrawnPending: CommerceMonetaryValue;
}>;

export type PayoutAccountWithdrawal = Readonly<{
  id: string;
  status: RegistryPayoutAccountWithdrawalStatus;
  totalValue: CommerceMonetaryValue;
}>;

export type CommerceMonetaryValue = Readonly<{
  currencyCode: string;
  valueInMinorUnits: number;
  valueInMajorUnits: number;
}>;

type CreditCardSetupContext = Readonly<{
  setSetupCreditCard: (nextValue: string | null) => void;
  fetchingPayoutInfo: boolean;
  /** Returns 'true' when there was a successful withdrawal in current session */
  hasDoneWithdrawal: boolean;
  hasFailedWithdrawals: boolean;
  hasPendingWithdrawals: boolean;
  payoutAccountInfo: PayoutAccountInfo | null;
  maxAttemptsReached: boolean;
  initKYCOnboarding: () => void;
  initKYCOnboardingFromRefund: (returnRoute: string) => void;
  initKYCLaterOnboarding: (firstName: string, lastName: string) => Promise<boolean>;
  fetchPayoutInfo: () => void;
  onOpenPayoutDialog: () => void;
  onOpenTransferToBankDialog: () => void;
  initPayoutAccountLoading: boolean;
  initKYCLaterLoading: boolean;
}>;

export const [Provider, useCreditCardSetupContext] = createContext<CreditCardSetupContext>({ name: 'CreditCardSetUpContext' });
